import Vue from '../../lib/vue2.js';




// nivas select
Vue.component('inputCustomSelect', {
    template: '#inputCustomSelect',
    components: {
    },
    props: {
        selected: {type: String,  default: ''},
        multiple: false,
        enableEmptyOption: false,
        enableImage: false,
        options: {type: Array,  default: () => []},
        placeholder: ''
    },
    watch: {
    },
    data: function () {
        return {
            dropdownActive: false,
            selectedStr: '',
            selectedArr: [],
            selectedImageUrl: '',
            items: {}
        };
    },
    mounted: function() {


    },
    created: function () {
        let component = this;

        console.log('created inputCustomSelect component');

        // global event for click outside 
        this.__handlerRef__ = this.onClickOutside.bind(this);
        window.addEventListener('click', this.__handlerRef__);
        
        this.createModel();
    },
    beforeDestroy() {
        let component = this;

        // remove global event for click outside
        this.__handlerRef__ = this.onClickOutside.bind(this);
        window.removeEventListener('click', this.__handlerRef__);
    },
    methods: {
        createModel: function() {
            let model  = {};
            this.selectedStr = this.placeholder;
            this.selectedArr = this.selected.split(",");
            this.selectedImageUrl = '';

            if(this.enableEmptyOption)
            {
                model[''] = {
                    selected: false,
                    label: this.placeholder,
                    value: ''
                };
            }

            for(let i in this.options)
            {
                let option = this.options[i];
                model[option.value] = option;
                model[option.value]['selected'] = false;

                if(this.selectedArr[0]!==undefined && this.selectedArr[0]==option.value)
                {
                    model[option.value]['selected'] = true;
                    this.selectedStr = option.label;
                    this.selectedImageUrl = option.imageUrl;
                    
                    this.$emit('input', option.value);
                }
            }



            this.items = model;
        },
        toggleDropdown: function() {
            this.dropdownActive = !this.dropdownActive;
        },
        closeDropdown: function() {
            this.dropdownActive = false;
        },
        openDropdown: function() {
            this.dropdownActive = true;
        },
        onSelect: function(item) {

            for(let i in this.items)
            {
                this.items[i]['selected'] = false; 
            }

            item.selected = true;
            this.selectedStr = item.label;
            this.selectedImageUrl = item.imageUrl;
            this.modelValue = item.value;
            
            this.$emit('input', item.value);

            this.closeDropdown();
        },
        onClickOutside: function (e) {

            if (
                this.$refs.selectEl!==undefined 
                && !this.$refs.selectEl.contains(e.target)
            ) {
                this.closeDropdown();
            }
        }
    }
});